import API from '../../utils/api';
import {
    MESSAGES_CLEARED,
    MESSAGES_FETCHED,
    MESSAGES_FETCHING_CHANGED,
    MESSAGES_FILTERS_STATUS_CHANGED,
    MESSAGES_HAS_MORE_CHANGED,
    MESSAGES_MESSAGE_DETAILS_CHANGED,
    MESSAGES_PAGE_CHANGED,
    MESSAGES_PAGINATED,
    MESSAGES_PAGINATING_CHANGED,
    PRIORITY_MESSAGES_FETCHED,
} from './types';
import {
    AGENT_SERVICE_ENDPOINT_URL,
    device_URI,
    MESSAGES_PAGE_SIZE,
} from '../../constants/defaultValues';
import { changeMessageModalProps } from './modals';

export const changeMessagesFetching = state => ({
    type: MESSAGES_FETCHING_CHANGED,
    payload: state,
});

export const changeMessagesPaginating = state => ({
    type: MESSAGES_PAGINATING_CHANGED,
    payload: state,
});

export const changeMessagesHasMore = state => ({
    type: MESSAGES_HAS_MORE_CHANGED,
    payload: state,
});

export const changeMessagesPage = page => ({
    type: MESSAGES_PAGE_CHANGED,
    payload: page,
});

export const changeMessagesSelectedStatus = status => ({
    type: MESSAGES_FILTERS_STATUS_CHANGED,
    payload: status,
});

export const clearMessages = () => ({
    type: MESSAGES_CLEARED,
});

export const changeMessageDetails = message => ({
    type: MESSAGES_MESSAGE_DETAILS_CHANGED,
    payload: message,
});

export const changeMessages = messages => ({
    type: MESSAGES_FETCHED,
    payload: messages,
});

export const getMessages = (query = {}) => async dispatch => {
    const changeLoading = state => {
        if (query.index === 0) {
            dispatch(clearMessages());
            dispatch(changeMessagesFetching(state));
        } else {
            dispatch(changeMessagesPaginating(state));
        }
    };

    changeLoading(true);

    try {
        const response = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/messages/page`, {
            params: query,
        });
        const { info, items } = response.data;

        if (!info.success) {
            changeLoading(false);
        }

        if (query.index === 0) {
            dispatch({
                type: MESSAGES_FETCHED,
                payload: items,
            });
        } else {
            dispatch({
                type: MESSAGES_PAGINATED,
                payload: items,
            });
        }
        dispatch(changeMessagesHasMore(items.length >= MESSAGES_PAGE_SIZE));
    } catch (error) {
        console.log(error);
        changeLoading(false);
    }
};

export const getPriorityMessages = () => async dispatch => {
    const query = {
        index: 0,
        status: 1,
        priorityStatus: 2,
    };
    try {
        const response = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/messages/page`, {
            params: query,
        });
        const { items } = response.data;

        dispatch(setPriorityMessages(items));

        return items;
    } catch (error) {
        console.log(error);
    }
};

export const setPriorityMessages = items => ({
    type: PRIORITY_MESSAGES_FETCHED,
    payload: items,
});

export const openFirstPriorityMessage = messageList => async dispatch => {
    if (messageList?.length) {
        dispatch(getMessageDetails(messageList[messageList.length - 1].id));
        dispatch(
            changeMessageModalProps({
                isVisible: true,
                isNewMessage: true,
            })
        );
    }
};

export const resetMessageModal = () => async dispatch => {
    dispatch(changeMessageDetails({}));
    dispatch(
        changeMessageModalProps({
            isVisible: false,
            isNewMessage: false,
        })
    );
};

export const getMessageDetails = messageId => async dispatch => {
    try {
        const response = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/messages/${messageId}`);
        const { info, item } = response.data;

        if (!info.success) {
            return;
        }

        dispatch(changeMessageDetails(item));
    } catch (error) {
        console.log(error);
    }
};

export const pinMessage = id => async dispatch => {
    try {
        const response = await API.post(`${AGENT_SERVICE_ENDPOINT_URL}/messages/pin/${id}`);

        dispatch(getMessageDetails(id));
    } catch (error) {
        console.log(error);
    }
};

export const unpinMessage = id => async dispatch => {
    try {
        const response = await API.post(`${AGENT_SERVICE_ENDPOINT_URL}/messages/unpin/${id}`);

        dispatch(getMessageDetails(id));
    } catch (error) {
        console.log(error);
    }
};

export const printMessage = async messageData =>
    await API.post(`${device_URI}/api/print/message`, messageData);
